import { c as _c } from "react/compiler-runtime";
import { CenterAligned, classNames, FlexCenter, TextBody, UnstyledButton, VerticalAligned } from "@opensea/ui-kit";
import { useOnChange } from "@opensea/ui-kit/hooks";
import { ChevronRight, VolumeOff, VolumeUp } from "@opensea/ui-kit/icons";
import { useTranslations } from "next-intl";
import { useRef, useState } from "react";
import ReactHlsPlayer from "react-hls-video-player";
import { IntroComponent } from "./IntroStep";
import { StepContainer } from "./Step";
const POSTER_TIME = 20;
const TRANSITION_CLASS_NAMES = classNames("transition-all duration-1000 ease-out-quint");
export function FilmStep(props) {
  const $ = _c(53);
  const t = useTranslations("FilmStep");
  const [muted, setMuted] = useState(false);
  const [paused, setPaused] = useState(false);
  const playerRef = useRef(null);
  const [filmComplete, setFilmComplete] = useState(false);
  let t0;
  if ($[0] !== filmComplete || $[1] !== paused) {
    t0 = () => {
      if (!playerRef.current || filmComplete) {
        return;
      }
      if (paused) {
        playerRef.current.play();
      } else {
        playerRef.current.pause();
      }
    };
    $[0] = filmComplete;
    $[1] = paused;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  useOnChange(paused, t0);
  let t1;
  if ($[3] !== muted) {
    t1 = () => {
      if (!playerRef.current) {
        return;
      }
      playerRef.current.muted = muted;
    };
    $[3] = muted;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  useOnChange(muted, t1);
  let resetFilmState;
  let skip;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    skip = () => {
      resetFilmState(true);
    };
    resetFilmState = t2 => {
      const forceFilmComplete = t2 === undefined ? false : t2;
      setFilmComplete(forceFilmComplete);
      if (playerRef.current) {
        if (forceFilmComplete) {
          playerRef.current.pause();
          playerRef.current.currentTime = POSTER_TIME;
        } else {
          playerRef.current.currentTime = 0;
        }
      }
    };
    $[5] = resetFilmState;
    $[6] = skip;
  } else {
    resetFilmState = $[5];
    skip = $[6];
  }
  let t2;
  if ($[7] !== props.className) {
    t2 = classNames("!p-0 fixed", props.className);
    $[7] = props.className;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== filmComplete || $[10] !== props.presented) {
    t3 = props.presented ? <UnstyledButton className="!contents" onClick={() => setPaused(_temp)}><ReactHlsPlayer autoPlay={true} className={classNames("block size-full bg-black", TRANSITION_CLASS_NAMES, "transition-opacity", filmComplete ? "object-cover opacity-15" : "object-contain")} onEnded={() => {
        resetFilmState(true);
      }} playerRef={playerRef} playsInline={true} src="https://stream.mux.com/Sh01VeipNiYn5GhLzA6LS8KFDN2vXjBIqBrtSrqXZZ4E.m3u8" /></UnstyledButton> : null;
    $[9] = filmComplete;
    $[10] = props.presented;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const t4 = !props.completed && filmComplete && "pointer-events-auto scale-100 opacity-100";
  let t5;
  if ($[12] !== t4) {
    t5 = classNames("fixed inset-0", TRANSITION_CLASS_NAMES, "pointer-events-none scale-90 opacity-0", t4);
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t) {
    t6 = t("getStartedLabel");
    $[14] = t;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t) {
    t7 = t("heading");
    $[16] = t;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== props) {
    t8 = () => {
      resetFilmState();
      props.onConfirm();
    };
    $[18] = props;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => {
      if (!playerRef.current) {
        return;
      }
      resetFilmState();
      playerRef.current.play();
    };
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t) {
    t10 = t("watchFilmLabel");
    $[21] = t;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t10 || $[24] !== t6 || $[25] !== t7 || $[26] !== t8) {
    t11 = <IntroComponent getStartedLabel={t6} heading={t7} onClickGetStarted={t8} onClickWatchFilm={t9} watchFilmLabel={t10} />;
    $[23] = t10;
    $[24] = t6;
    $[25] = t7;
    $[26] = t8;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== t11 || $[29] !== t5) {
    t12 = <CenterAligned className={t5}>{t11}</CenterAligned>;
    $[28] = t11;
    $[29] = t5;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  const t13 = (props.completed || filmComplete) && "-translate-y-1 pointer-events-none opacity-0";
  let t14;
  if ($[31] !== t13) {
    t14 = classNames("absolute inset-x-0 top-0 justify-between px-3 py-4", "transition duration-500 ease-out-quint", t13);
    $[31] = t13;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = () => setMuted(_temp2);
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== muted) {
    t16 = <VerticalAligned className="ml-1 h-[30px]"><UnstyledButton className="flex justify-center gap-1" onClick={t15}>{muted ? <VolumeOff fill="text-primary" /> : <VolumeUp fill="text-primary" />}</UnstyledButton></VerticalAligned>;
    $[34] = muted;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== t) {
    t17 = t("skip");
    $[36] = t;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== t17) {
    t18 = <TextBody size="sm" weight="semibold">{t17}</TextBody>;
    $[38] = t17;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <ChevronRight fill="text-primary" />;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  let t20;
  if ($[41] !== t18) {
    t20 = <VerticalAligned className="h-[30px]"><UnstyledButton className="flex justify-center gap-1" onClick={skip}>{t18}{t19}</UnstyledButton></VerticalAligned>;
    $[41] = t18;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  let t21;
  if ($[43] !== t14 || $[44] !== t16 || $[45] !== t20) {
    t21 = <FlexCenter className={t14}>{t16}{t20}</FlexCenter>;
    $[43] = t14;
    $[44] = t16;
    $[45] = t20;
    $[46] = t21;
  } else {
    t21 = $[46];
  }
  let t22;
  if ($[47] !== props || $[48] !== t12 || $[49] !== t2 || $[50] !== t21 || $[51] !== t3) {
    t22 = <StepContainer {...props} className={t2}>{t3}{t12}{t21}</StepContainer>;
    $[47] = props;
    $[48] = t12;
    $[49] = t2;
    $[50] = t21;
    $[51] = t3;
    $[52] = t22;
  } else {
    t22 = $[52];
  }
  return t22;
}
function _temp2(m) {
  return !m;
}
function _temp(p) {
  return !p;
}